import axios from 'axios'

class UploadService {
  constructor () {
    this.api = axios.create({
      baseURL: 'https://us-central1-zaper-id.cloudfunctions.net'
    })
  }

  toBase64 (file) {
    if (typeof file === 'string') {
      return file
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  async upload ({ image, userId }) {
    const { data } = await this.api.post('/upload', { image: await this.toBase64(image), userId })

    if (data.error) {
      alert('Oops! Ocorreu um erro ao tentar realizar o upload do arquivo. Tente novamente mais tarde.')
      throw new Error('')
    }

    return data.url
  }

  async getPhotosByUnsplash ({ search, page }) {
    const { data } = await this.api.get(`/unsplash?page=${page || 1}&search=${search}`)
    return data
  }
}

export default new UploadService()
